










import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { InvoiceModel } from "../models";

import InvoiceTable from "../components/InvoiceTable.vue";

const iStore = namespace("invoices");
const snackStore = namespace("snackbar");

@Component({
  components: { InvoiceTable }
})
export default class MyInvoices extends Vue {
  @iStore.Getter allInvoices!: InvoiceModel;

  @iStore.Action fetchInvoices!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  mounted() {
    this.fetchInvoices().catch(() => {
      this.defaultError();
    });
  }
}
